<template>
    <div class="wide-account">
        <div class="wrapper">
            <div class="row header">
                <div v-if="isMobile" class="nav-mobile">
                    <router-link
                        to="/account"
                        class="nav-link"
                    > Личный кабинет </router-link>
                    <div
                        class="logout-line"
                        @click="signOut"
                    >
                        <div>
                            <div class="logout-container">
                                <span class="logout-icon dont-hide-img"></span>
                                <span class="logout-text">Выйти из профиля</span>
                            </div>
                        </div>
                    </div>
                </div>
                <h1>Мои данные</h1>
                <div
                    class="logout-line"
                    v-if="!isMobile"
                >
                    <div>
                        <div 
                            class="logout-container"
                            @click="signOut"
                        >
                            <span class="logout-icon"></span>
                            <span class="logout-text">Выйти из профиля</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div>
                    <TabsSelector
                        v-if="isMobile"
                        :activeField="tabActiveField"
                        :isBgMode="true"
                        @change-field="setField"
                        :slotsHeaders='activeTabs.map((elem) => {
                            return {
                                title: elem.title,
                                bullet: elem.bullet,
                            }
                        })'
                    >
                        <template
                            v-for="(item, index) in activeTabs"
                            :slot="item.name"
                        >
                            <component
                                :is="item.componentName"
                                :key="`tab-index-${index}`"
                                v-loading="!serverSuccess"
                            ></component>
                        </template>
                    </TabsSelector>
                    <Tabs
                        v-if="!isMobile"
                        :activeField="tabActiveField"
                        :isBgMode="true"
                        @change-field="setField"
                        :slotsHeaders='activeTabs.map((elem) => {
                            return {
                                title: elem.title,
                                bullet: elem.bullet,
                            }
                        })'
                    >
                        <template
                            v-for="(item, index) in activeTabs"
                            :slot="item.name"
                        >
                            <component
                                :is="item.componentName"
                                :key="`tab-index-${index}`"
                                v-loading="!serverSuccess"
                            ></component>
                        </template>
                    </Tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WideMainData from './main/WideMainData';
import WideContactsData from './contacts/WideContactsData';
import WideDocsData from './docs/WideDocsData';
import WideCareerData from './career/WideCareerData';
import WideEducationData from './education/WideEducationData';
import WideOtherData from './other/WideOtherData';
import WideParticipationInProjectsData from './participation_in_projects/WideParticipationInProjectsData';
import Tabs from '../../UI/Tabs';
import TabsSelector from '../../UI/TabsSelector';
import TabStub from './../tabs/TabStub';
import { securityService } from "@/tools/sequrity_service";

import { mapGetters } from 'vuex';

const getters = [
    'userProfileAge',
    'userProfileInfo',
    'user',
    'isMobile',
];

export default {
    name: 'WideAccountData',
    data: () => ({
        tabActiveField: 0,
        tabs: [
            {
                name: 'MainTab',
                title: 'Основные',
                componentName: 'WideMainData',
                show: true,
            },
            {
                name: 'ContactsTab',
                title: 'Контакты',
                componentName: 'WideContactsData',
                show: true,
            },
            {
                name: 'LearnTab',
                title: 'Образование',
                componentName: 'WideEducationData',
                show: true,
            },
            {
                name: 'CareerTab',
                title: 'Карьера',
                componentName: 'WideCareerData',
                show: true,
            },
            {
                name: 'DocumentsTab',
                title: 'Документы',
                componentName: 'WideDocsData',
                show: true,
            },
            {
                name: 'ElseTab',
                title: 'Прочее',
                componentName: 'WideOtherData',
                show: true,
            },
            {
                name: 'ParticipationInProjectsTab',
                title: 'Участие в проектах',
                componentName: 'WideParticipationInProjectsData',
                show: false,
            },
        ],
    }),
    methods: {
        setField(index) {
            if (this.serverSuccess) {
                this.tabActiveField = index;
            }
        },

        updateTabsVisibility() {
            // Docs tab
            let index = this.tabs.findIndex((v) => v.name === 'DocumentsTab');
            this.$set(this.tabs[index], 'show', this.userProfileAge >= 18);
        },
        signOut() {
            this.$root.securityService.signOut();
        },
    },

    computed: {
        ...mapGetters(getters),

        serverSuccess() {
            return (Object.keys(this.userProfileInfo).length > 0)
                && this.user.id;
        },

        activeTabs() {
            return this.tabs.filter(v => v.show);
        },
    },

    mounted() {
        this.updateTabsVisibility();
        if (this.$route.query.tab) {
            this.tabActiveField = +this.$route.query.tab;
        }
    },

    watch: {
        userProfileAge() {
            this.updateTabsVisibility();
        },
    },

    components: {
        TabsSelector,
        Tabs,
        TabStub,
        WideMainData,
        WideOtherData,
        WideParticipationInProjectsData,
        WideContactsData,
        WideCareerData,
        WideDocsData,
        WideEducationData,
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';
    @import '../../../styles/mrem';

    .wide-account {
        color: #2A2626;
        display: flex;
        justify-content: center;

        .wrapper {
            /*background: #1DB810;*/
            width: 80%;
        }

        .col-2 {
            width: 50%;
            display: inline-block;
            padding: 0.7rem;
        }

        .bg {
            width: 100%;
            padding: 1rem;
            background: #FFFFFF;
            box-shadow: 0 6px 10px rgba(131, 134, 163, 0.12);
            border-radius: rem(4);
        }
    }

    .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        margin: rem(40) 0 rem(32) 0;

        h1 {
            margin: 0;
            font-size: rem(34);
        }

        .logout-line {
            border-bottom: rem(1) solid #EF627D;
            padding-bottom: rem(4);

            * {
                color: #EF627D;
                font-size: rem(12);
            }

            .logout-container {
                cursor: pointer;
                display: flex;
                flex-flow: row nowrap;
                justify-content: flex-start;
                align-items: center;
            }

            .logout-icon {
                width: rem(16);
                height: rem(16);
                background: url("../../../assets/images/logout.png") no-repeat center/contain;
            }

            .logout-text {
                margin-left: rem(11);
                line-height: rem(15);
            }
        }
    }

    @import "../../../styles/variables";
    @media (max-width: $vm) {

        .wide-account {
            background-color: #ffffff;

            .wrapper {
                width: 100%;
                padding: 0;
                //min-height: calc(90vh - 15rem);
            }

            .nav-link {
                position: relative;
                padding-left: mrem(14);
                font-size: mrem(12);
                line-height: mrem(15);
                font-weight: 600;
                color: #bac5cb;

                &::before {
                    content: url(../../../assets/images/contacts/nav-arrov-icon.svg);
                    position: absolute;
                    left: 0;
                    top: mrem(1);
                    width: mrem(8);
                    height: mrem(13);
                }
            }

            .header {
                display: block;
                margin: 0;
                padding: mrem(24) mrem(16);
                background-color: #F5F9FC;

                h1 {
                    margin: 0;
                    font-family: "Montserrat", sans-serif;
                    font-style: normal;
                    font-weight: bold;
                    font-size: mrem(24);
                }

                .nav-mobile {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: mrem(24);
                }

                .logout-line {
                    padding-bottom: mrem(1);

                    * {
                        font-size: mrem(10);
                    }

                    .logout-container {
                        margin-top: mrem(-1);
                    }

                    .logout-icon {
                        width: mrem(12);
                        height: mrem(12);
                        background: url("../../../assets/images/logout.png") no-repeat center/contain;
                    }

                    .logout-text {
                        margin-left: mrem(11);
                        line-height: mrem(15);
                    }
                }
            }
        }
    }
</style>
